import {EventEmitter, Injectable, Output} from '@angular/core';
import {ConfService} from './conf.service';
import {environment} from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IdletimeoutListenerService {

  @Output() idleTimeoutListener: EventEmitter<any> = new EventEmitter();


  constructor() {
    this.idleTimeoutListener.subscribe(
        (eventObject) => {
          // This listener has to be removed
        }
    );
  }
}
